import { useQuery } from '@tanstack/react-query';
import { api } from 'src/services';

export type Patient = {
  first_name: string;
  last_name: string;
  gender: string;
  dob: string;
  phone_number: string;
};

export type Insurance = {
  name: string;
};

export type Clinic = {
  address: string;
  name: string;
};

export type Appointment = {
  id: string;
  clinic_id: number;
  clinic: Clinic;
  date: string;
  start_time: string;
  end_time: string;
  status: string;
  type: string;
  insurance_id: string;
  insurance: Insurance;
  patient_id: string;
  patient: Patient;
};

export type GetAppointmentsListResponse = {
  appointments: Appointment[];
};

export const useGetAppointments = () => {
  return useQuery({
    queryKey: ['appointmentsList'],
    queryFn: () =>
      api
        .get<GetAppointmentsListResponse>('/v3/frontdesk/appointments')
        .then((res) => ({ appointmentList: res.data?.appointments })),
  });
};

export type AppointmentSlot = {
  id: string;
  clinic_id: number;
  date: string;
  start_time: string;
  end_time: string;
  status: string;
  provider_id: string;
  provider_name: string;
  slot_type: string;
  duration_minutes: number;
};

export type GetAppointmentSlotListResponse = {
  slots: AppointmentSlot[];
};

export const useGetAppointmentSlotList = () => {
  return useQuery({
    queryKey: ['appointmentSlotList'],
    queryFn: () =>
      api
        .get<GetAppointmentSlotListResponse>('/v3/frontdesk/appointment_slots')
        .then((res) => ({ appointmentSlotList: res.data?.slots })),
  });
};
